export default __webpack_public_path__ + "static/media/K2D-ExtraLight.d5e4b81a.ttf";